import React, { useEffect, useState, Fragment } from "react";
import { Link } from "react-router-dom";
import Monthly_navbar from "./Monthlytasks_navbar";
import { Form, Spinner } from "react-bootstrap";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import Pagination from "../General/Pagination";
import moment from "moment";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { scrollToTop } from "../Shared/ScrollOnTop";
import SessionsDropDown from "../Shared/SessionsDropDown";
import config from "../../Config";
import * as XLSX from "xlsx";
const StartNewMonth2 = () => {
    document.title = "Post Fee";
    const [Month, setMonth] = useState(moment().format("M"));
    const [Year, setYear] = useState(moment().format("YYYY"));
    const [MonthForConcessions, setMonthForConcessions] = useState(
        moment().format("M")
    );
    const [YearForConcessions, setYearForConcessions] = useState(
        moment().format("YYYY")
    );
    const [MonthForArrears, setMonthForArrears] = useState(moment().format("M"));
    const [YearForArrears, setYearForArrears] = useState(moment().format("YYYY"));
    const [MonthForPostAdvance, setMonthForPostAdvance] = useState(
        moment().format("M")
    );
    const [YearForPostAdvance, setYearForPostAdvance] = useState(
        moment().format("YYYY")
    );
    const [MonthForDeleteFee, setMonthForDeleteFee] = useState(
        moment().format("M")
    );
    const [YearForDeleteFee, setYearForDeleteFee] = useState(
        moment().format("YYYY")
    );
    const [MonthForPostFine, setMonthForPostFine] = useState(
        moment().format("M")
    );
    const [YearForPostFine, setYearForPostFine] = useState(
        moment().format("YYYY")
    );

    const [MonthForPostAbsentFine, setMonthForPostAbsentFine] = useState(
        moment().format("M")
    );
    const [YearForPostAbsentFine, setYearForPostAbsentFine] = useState(
        moment().format("YYYY")
    );

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [User_Name, setUser_Name] = useState(localStorage.getItem("UserName"));
    const [MemberType, setMemberType] = useState(
        localStorage.getItem("MemberType")
    );

    const [TransportFee, setTransportFee] = useState(false);

    const [loading, setLoading] = useState(false);
    const [Concessionsloading, setConcessionsloading] = useState(false);
    const [Arrearsloading, setArrearsloading] = useState(false);
    const [AdjustAdvanceloading, setAdjustAdvanceloading] = useState(false);
    const [DeleteFeeloading, setDeleteFeeloading] = useState(false);
    const [PostFineloading, setPostFineloading] = useState(false);
    const [PostAbsentFineloading, setPostAbsentFineloading] = useState(false);
    const [DateForPostFine, setDateForPostFine] = useState();
    const [SessionId, setSessioinId] = useState(localStorage.getItem("DefaultSession"));
    const [ClassId, setClassId] = useState(0);
    const [Ledger, setLedger] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(1000000);
    const [totalRecords, setTotalRecords] = useState(0);
    const [StartMonthLoading, setStartMonthLoading] = useState(false)
    const [checkedItems, setCheckedItems] = useState({});
    const [classRemarksFlags, setClassRemarksFlags] = useState({});
    const [classRemarksText, setClassRemarksText] = useState({});
    const [selectedClassIds, setSelectedClassIds] = useState([]);
    const [selectedClassNames, setSelectedClassNames] = useState([]);
    const [classPostingStatus, setClassPostingStatus] = useState({});
    const [postingSummary, setPostingSummary] = useState({ done: 0, total: 0 });
    const [challanDueDate, setChallanDueDate] = useState("");
    const [BusTotalDays, setBusTotalDays] = useState(30);
    const [BusAvailDays, setBusAvailDays] = useState(30);
    const [feeAdjustRows, setFeeAdjustRows] = useState([]);
    const [feeAdjustLoading, setFeeAdjustLoading] = useState(false);
    const [feeAdjustSummary, setFeeAdjustSummary] = useState(null);
    const [feeAdjustErrors, setFeeAdjustErrors] = useState([]);


    const handleDateChange = (event) => {
        setChallanDueDate(event.target.value);
    };


    const handleCheckboxChange = (classId, className, event) => {
        let tempCheckedItems = { ...checkedItems };
        tempCheckedItems[classId] = event.target.checked;
        setCheckedItems(tempCheckedItems);

        let updatedSelectedClassIds = [...selectedClassIds];
        let updatedSelectedClassNames = [...selectedClassNames];

        if (event.target.checked) {
            updatedSelectedClassIds.push(classId);
            updatedSelectedClassNames.push(className);
        } else {
            updatedSelectedClassIds = updatedSelectedClassIds.filter(id => id !== classId);
            updatedSelectedClassNames = updatedSelectedClassNames.filter(name => name !== className);
            setClassRemarksFlags((prev) => {
                const next = { ...prev };
                delete next[classId];
                return next;
            });
            setClassRemarksText((prev) => {
                const next = { ...prev };
                delete next[classId];
                return next;
            });
        }

        // Update the state
        setSelectedClassIds(updatedSelectedClassIds);
        setSelectedClassNames(updatedSelectedClassNames);
    };

    const handleClassRemarksToggle = (classId, checked) => {
        setClassRemarksFlags((prev) => ({ ...prev, [classId]: checked }));
        if (!checked) {
            setClassRemarksText((prev) => {
                const next = { ...prev };
                delete next[classId];
                return next;
            });
        }
    };

    const handleClassRemarksText = (classId, value) => {
        setClassRemarksText((prev) => ({ ...prev, [classId]: value }));
    };


    const handleSelectAll = (event) => {
        let tempCheckedItems = {};
        let updatedSelectedClassIds = [];
        let updatedSelectedClassNames = [];

        if (event.target.checked) {
            Ledger.forEach((item) => {
                item.ListofClassesInWing.forEach((detail) => {
                    tempCheckedItems[detail.Class_Id] = true;
                    updatedSelectedClassIds.push(detail.Class_Id);
                    updatedSelectedClassNames.push(detail.Class_Name);
                });
            });
        } else {
            Ledger.forEach((item) => {
                item.ListofClassesInWing.forEach((detail) => {
                    tempCheckedItems[detail.Class_Id] = false;
                });
            });
            updatedSelectedClassIds = [];
            updatedSelectedClassNames = [];
            setClassRemarksFlags({});
            setClassRemarksText({});
        }

        setCheckedItems(tempCheckedItems);
        setSelectedClassIds(updatedSelectedClassIds);
        setSelectedClassNames(updatedSelectedClassNames);
    };

    //console.log(selectedClassIds);


    useEffect(() => {
        GetClassesBySessionID();

        const today = new Date();

        const tenDaysFromNow = new Date(today);
        tenDaysFromNow.setDate(today.getDate() + 10);
        const formattedDate = tenDaysFromNow.toISOString().split('T')[0];

        setChallanDueDate(formattedDate);
    }, [SessionId])

    const GetClassesBySessionID = () => {
        setLoading(true)
        const dashboardParms = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            PageNo: pageNo,
            PageSize: pageSize,
            SessionID: SessionId
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Wings/GetSchoolWingWithClasses',
            headers: {
                'Content-Type': 'application/json'
            },
            data: dashboardParms
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code != 0) {
                    setLedger(response.data.SchoolWing || []);
                    setTotalRecords(response.data.SchoolWing.length || 0);
                    setLoading(false);
                }
                else {
                    setLedger([]);
                    setTotalRecords(0);
                    setLoading(false);
                }

            })
            .catch(function (error) {
                ////console.log(error);
                setLoading(false);
            });
    }

    const renderLedger = () => {

        if (Ledger != null && Ledger.length > 0) {
            return (
                Ledger.map((item, index) => {
                    return (
                        <Fragment key={item.id}>
                            <tr>
                                <td colSpan={7} className="fw-bold">
                                    Wing: {item.Wing_Detail}{" "}
                                </td>
                            </tr>
                            {item.ListofClassesInWing && (
                                <>
                                    {item.ListofClassesInWing.map((detail) => (
                                        <Fragment key={`cls-${detail.Class_Id}`}>
                                            <tr>
                                                <td>{detail.Class_Id}</td>
                                                <td>{detail.Class_Code}</td>
                                                <td>{detail.Class_Short_Name}</td>
                                                <td>{detail.Class_Name}</td>
                                                <td>{detail.Selected_Session.Session_Name}</td>
                                                <td style={{ verticalAlign: "top", maxWidth: 420 }}>
                                                    <div>
                                                        {classPostingStatus[detail.Class_Id]?.status === "processing" && (
                                                            <span className="text-primary">In Process</span>
                                                        )}
                                                        {classPostingStatus[detail.Class_Id]?.status === "done" && (
                                                            <span className="text-success">Completed</span>
                                                        )}
                                                        {classPostingStatus[detail.Class_Id]?.status === "failed" && (
                                                            <span className="text-danger">Failed</span>
                                                        )}
                                                        {!classPostingStatus[detail.Class_Id] && (
                                                            <span className="text-muted">Waiting</span>
                                                        )}
                                                    </div>
                                                    {classPostingStatus[detail.Class_Id]?.status === "failed" &&
                                                    (classPostingStatus[detail.Class_Id]?.message || "").trim() ? (
                                                        <div
                                                            className="small text-danger mt-1 ps-0"
                                                            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                                                            title={(classPostingStatus[detail.Class_Id].message || "").trim()}
                                                        >
                                                            {(classPostingStatus[detail.Class_Id].message || "").trim()}
                                                        </div>
                                                    ) : null}
                                                    {classPostingStatus[detail.Class_Id]?.status === "done" &&
                                                    (classPostingStatus[detail.Class_Id]?.message || "").trim() ? (
                                                        <div
                                                            className="small text-muted mt-1"
                                                            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                                                        >
                                                            {(classPostingStatus[detail.Class_Id].message || "").trim()}
                                                        </div>
                                                    ) : null}
                                                </td>
                                                <td><div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`checkbox-${detail.Class_Id}`}
                                                        value={detail.Class_Id}
                                                        checked={!!checkedItems[detail.Class_Id]}
                                                        onChange={(e) => handleCheckboxChange(detail.Class_Id, detail.Class_Name, e)}
                                                    />
                                                </div>
                                                </td>
                                            </tr>
                                            {checkedItems[detail.Class_Id] ? (
                                                <tr className="bg-light">
                                                    <td colSpan={7} className="py-2">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`challan-remarks-${detail.Class_Id}`}
                                                            className="mb-2"
                                                            label="Add remarks on challans for this class"
                                                            checked={!!classRemarksFlags[detail.Class_Id]}
                                                            onChange={(e) =>
                                                                handleClassRemarksToggle(detail.Class_Id, e.target.checked)
                                                            }
                                                        />
                                                        {classRemarksFlags[detail.Class_Id] ? (
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={2}
                                                                maxLength={4000}
                                                                placeholder="Saved on each student challan (tblChalanHead.Remarks) for this posting."
                                                                value={classRemarksText[detail.Class_Id] || ""}
                                                                onChange={(e) =>
                                                                    handleClassRemarksText(detail.Class_Id, e.target.value)
                                                                }
                                                            />
                                                        ) : null}
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </Fragment>
                                    ))}
                                </>
                            )}
                        </Fragment>
                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colSpan="7"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }

    const handleMonth = () => {
        setStartMonthLoading(true);

        if (selectedClassIds.length <= 0) {
            toast.error("Please select atleast one class", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setStartMonthLoading(false);
            return;
        }
        const classPairs = selectedClassIds.map((id, index) => ({
            classId: id,
            className: selectedClassNames[index]
        }));

        const initialStatuses = {};
        classPairs.forEach((item) => {
            initialStatuses[item.classId] = { status: "pending", message: "" };
        });
        setClassPostingStatus(initialStatuses);
        setPostingSummary({ done: 0, total: classPairs.length });

        const postClassesSequentially = async () => {
            for (let i = 0; i < classPairs.length; i++) {
                const item = classPairs[i];
                setClassPostingStatus((prev) => ({
                    ...prev,
                    [item.classId]: { status: "processing", message: "" },
                }));

                const useRemarks = !!classRemarksFlags[item.classId];
                const remarksText = (classRemarksText[item.classId] || "").trim();
                if (useRemarks && !remarksText) {
                    setClassPostingStatus((prev) => ({
                        ...prev,
                        [item.classId]: {
                            status: "failed",
                            message: 'Enter challan remarks or turn off "Add remarks on challans for this class".',
                        },
                    }));
                    setPostingSummary((prev) => ({
                        done: prev.done + 1,
                        total: prev.total,
                    }));
                    continue;
                }

                const data = {
                    AccessKey: AccessKey,
                    UserID: UserID,
                    MemberType: MemberType,
                    SelectedMonth: Month,
                    FYear: Year,
                    SessionID: SessionId,
                    AddTransportFee: TransportFee,
                    SeletedClassIDs: [item.classId],
                    SeletedClassNames: [item.className],
                    UserName: User_Name,
                    Challan_DueDate: challanDueDate,
                    BusTotalDays: BusTotalDays,
                    BusAvailDays: BusAvailDays,
                    Remarks: useRemarks && remarksText ? remarksText : null,
                };
                const api_config = {
                    method: "post",
                    url: config.base_url + "/ADLedger/StartNewMonthWithADByClass",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    data: data,
                };

                try {
                    const response = await axios(api_config);
                    if (response.data.status_code == 1) {
                        setClassPostingStatus((prev) => ({
                            ...prev,
                            [item.classId]: { status: "done", message: response.data.status_message || "" },
                        }));
                    } else {
                        const msg =
                            response.data?.status_message ||
                            response.data?.message ||
                            `Request failed (status_code: ${response.data?.status_code ?? "unknown"})`;
                        setClassPostingStatus((prev) => ({
                            ...prev,
                            [item.classId]: { status: "failed", message: msg },
                        }));
                    }
                } catch (error) {
                    const msg =
                        error?.response?.data?.status_message ||
                        error?.response?.data?.message ||
                        error?.message ||
                        "Network or server error";
                    setClassPostingStatus((prev) => ({
                        ...prev,
                        [item.classId]: { status: "failed", message: msg },
                    }));
                }

                setPostingSummary((prev) => ({
                    done: prev.done + 1,
                    total: prev.total,
                }));
            }
            setStartMonthLoading(false);
        };

        postClassesSequentially();
    };

    const handleAdjustAdvance = () => {
        setAdjustAdvanceloading(true);
        const data = {
            AccessKey: AccessKey,
            MemberType: MemberType,
            UserID: UserID,
            SelectedMonth: MonthForPostAdvance,
            FYear: YearForPostAdvance,
        };

        const api_config = {
            method: "post",
            url: config.base_url + "ADLedger/AdjustAdvance",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };
        //console.log(data);
        axios(api_config)
            .then(function (response) {
                //console.log("response", response.data);
                if (response.data.status_code == 1) {
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });

                    setAdjustAdvanceloading(false);
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setAdjustAdvanceloading(false);
                }
            })
            .catch(function (error) {
                setAdjustAdvanceloading(false);
                toast.error("Network Error..", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    const handleFeeAdjustFileChange = (event) => {
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            const rows = jsonData.map((row) => {
                const normalized = {};
                Object.keys(row || {}).forEach((key) => {
                    const normalizedKey = String(key).toLowerCase().replace(/\s+/g, "");
                    normalized[normalizedKey] = row[key];
                });

                const serial = normalized["serialno"] ?? normalized["serial_no"] ?? "";
                const reg = normalized["registration_no"] ?? normalized["registrationno"] ?? normalized["registration"] ?? "";
                const feeCode = normalized["feetypecode"] ?? normalized["feetype_code"] ?? normalized["feecode"] ?? "";
                const amount = normalized["amount"] ?? "";

                return {
                    SerialNo: String(serial ?? "").trim(),
                    Registration_No: String(reg ?? "").trim(),
                    FeeTypeCode: String(feeCode ?? "").trim(),
                    Amount: String(amount ?? "").trim(),
                };
            });

            setFeeAdjustRows(rows);
            setFeeAdjustSummary(null);
            setFeeAdjustErrors([]);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleImportFeeAdjustments = () => {
        if (!Month || !Year) {
            toast.error("Please select month and year.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        if (!feeAdjustRows || feeAdjustRows.length === 0) {
            toast.error("Please select an Excel file first.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        setFeeAdjustLoading(true);
        setFeeAdjustSummary(null);
        setFeeAdjustErrors([]);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            SelectedMonth: Number(Month),
            FYear: Number(Year),
            Rows: feeAdjustRows,
        };

        const api_config = {
            method: "post",
            url: config.base_url + "ADLedger/ImportFeeAdjustments",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setFeeAdjustSummary({
                        Inserted: response.data.Inserted || 0,
                        Skipped: response.data.Skipped || 0,
                    });
                    setFeeAdjustErrors(response.data.Errors || []);
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else {
                    setFeeAdjustErrors(response.data.Errors || []);
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
                setFeeAdjustLoading(false);
            })
            .catch(function (error) {
                setFeeAdjustLoading(false);
                toast.error("Network Error..", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };
    //console.log(TransportFee)
    return (
        <>
            <Monthly_navbar />
            <ToastContainer />

            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/MonthlyTasks/MonthlyTasksDashboard">
                                            Fee Posting
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Post Fee
                                    </li>
                                </ol>
                            </nav>
                            <div className="page-title">Post Fee</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link
                                    to="/MonthlyTasks/ManageMonth"
                                    className="button button-white button-icon"
                                >
                                    Manage Posted Fee
                                    <i className="ri-list-check"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">
                    <div className="card mb-2">
                        <div className="card-body">
                            <div className="bg-light p-md-4">
                                <p className="mb-1">
                                    Post Fee is a Fee Posting and will be perform to add
                                    dues in the students ledger, just verify the date and click on
                                    the button below, this will update the ledgers with current
                                    feeses mentioned as monthly fee in classes defination.
                                </p>
                                <h5>
                                    <b>Note:</b>
                                </h5>
                                <p className="mb-0">
                                    This Process may take a little time to post enteries in the
                                    system so do not press the button twice and wait for its
                                    completion.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="container mt-2">
                    <div className="card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label className="">Select Session:</label>
                                        <select className="form-select"
                                            onChange={(e) => { setSessioinId(e.target.value); setClassId(0); }}
                                            name="SessionID">
                                            <option value="0">---All---</option>
                                            <SessionsDropDown selectedSession={SessionId} />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>Current Month</label>
                                        <select
                                            className="form-select"
                                            onChange={(e) => setMonth(e.target.value)}
                                        >
                                            <option value="">Please Select</option>
                                            <MonthsDropDown />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>Current Year</label>
                                        <select
                                            className="form-select"
                                            onChange={(e) => setYear(e.target.value)}
                                        >
                                            <option value="">Please Select</option>
                                            <YearsDropDown />
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>Today</label>
                                        <input
                                            disabled
                                            className="form-control"
                                            value={moment().format("h:mm A")}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>Challan Due Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={challanDueDate}
                                            required
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <Form.Group className="mt-4">
                                        <Form.Check
                                            required
                                            label="Add Transport Fee:"
                                            feedbackType="invalid"
                                            checked={TransportFee}
                                            onChange={(e) => setTransportFee(e.target.checked)}
                                        />
                                    </Form.Group>
                                </div>
                                {TransportFee ?
                                    <>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Bus Month Days</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={BusTotalDays}
                                                    required
                                                    onChange={(e) => setBusTotalDays(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Bus Avail Days</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={BusAvailDays}
                                                    required
                                                    onChange={(e) => setBusAvailDays(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                    : null}

                            </div>

                            <div className="card mt-3">
                                <div className="card-body table-wrap">
                                    <table className="table table-theme table-hover">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Class ID
                                                </th>
                                                <th>
                                                    Class Code
                                                </th>
                                                <th>
                                                    Class Short Name
                                                </th>
                                                <th>
                                                    Class Name
                                                </th>
                                            <th>
                                                Session
                                            </th>
                                            <th>Status</th>
                                            <th><div class="form-check">
                                                <input class="form-check-input" type="checkbox" value=""
                                                    onChange={handleSelectAll}
                                                    id="flexCheckDefault" />
                                            </div></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                loading ?
                                                    <tr>
                                                        <td className="text-center" colSpan="8">
                                                            <Spinner animation="border" role="status"></Spinner>
                                                        </td>
                                                    </tr>
                                                    :
                                                    <>
                                                        {renderLedger()}
                                                    </>

                                            }
                                        </tbody>
                                    </table>
                                    {
                                        totalRecords > { pageSize } &&
                                        <div className="pagination-wrap">

                                            <div className="row align-items-center">
                                                <div className="col-md-2 form_default">
                                                    <div className="d-flex align-items-center">
                                                        <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                        <div className="form-group">
                                                            <select className="form-select"
                                                                style={{ width: "100px" }}
                                                                onChange={(e) => {
                                                                    setPageNo(1);
                                                                    setPageSize(parseInt(e.target.value));


                                                                }}>
                                                                <option value="10" selected>10</option>
                                                                <option value="20">20</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                                <option value="500">500</option>


                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <Pagination
                                                    pageNo={pageNo}
                                                    pageSize={pageSize}
                                                    totalRecords={totalRecords}
                                                />
                                            </div>
                                        </div>

                                    }

                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center text-end mt-3">
                                <div className="text-muted">
                                    {postingSummary.total > 0 ? `Completed ${postingSummary.done} / ${postingSummary.total}` : ""}
                                </div>
                                {StartMonthLoading ? (
                                    <Spinner animation="border" role="status"></Spinner>
                                ) : (
                                    <button
                                        type="submit"
                                        className="button button-primary "
                                        onClick={handleMonth}
                                    >
                                        Post Fee{" "}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-2">
                    <div className="card">
                        <div className="card-body">
                            <div className="row align-items-end">
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>Current Month</label>
                                        <select
                                            className="form-select"
                                            onChange={(e) => setMonthForPostAdvance(e.target.value)}
                                        >
                                            <option value="">Please Select</option>
                                            <MonthsDropDown />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>Current Year</label>
                                        <select
                                            className="form-select"
                                            onChange={(e) => setYearForPostAdvance(e.target.value)}
                                        >
                                            <option value="">Please Select</option>
                                            <YearsDropDown />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2 offset-md-6 text-end">
                                    {AdjustAdvanceloading ? (
                                        <Spinner animation="border" role="status"></Spinner>
                                    ) : (
                                        <button
                                            type="button"
                                            className="button button-primary w-100"
                                            onClick={handleAdjustAdvance}
                                        >
                                            Adjust Advances
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-2">
                    <div className="card">
                        <div className="card-body">
                            <div className="bg-light p-md-3 mb-3">
                                <p className="mb-1">
                                    Import fee adjustments after fee posting. The Excel file must include
                                    <b> SerialNo, Registration_No, FeeTypeCode, Amount</b>.
                                </p>
                                <p className="mb-0">
                                    Use a negative Amount to remove fee. Month/Year will be taken from above selection.
                                </p>
                            </div>
                            <div className="row align-items-end">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Excel File</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept=".xlsx,.xls,.csv"
                                            onChange={handleFeeAdjustFileChange}
                                        />
                                        <div className="form-text">
                                            Rows loaded: {feeAdjustRows.length}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 text-end">
                                    {feeAdjustLoading ? (
                                        <Spinner animation="border" role="status"></Spinner>
                                    ) : (
                                        <button
                                            type="button"
                                            className="button button-primary w-100"
                                            onClick={handleImportFeeAdjustments}
                                        >
                                            Import Fee Adjustments
                                        </button>
                                    )}
                                </div>
                            </div>
                            {feeAdjustSummary && (
                                <div className="mt-3">
                                    <strong>Imported:</strong> {feeAdjustSummary.Inserted}{" "}
                                    <span className="ms-3">
                                        <strong>Skipped:</strong> {feeAdjustSummary.Skipped}
                                    </span>
                                </div>
                            )}
                            {feeAdjustErrors && feeAdjustErrors.length > 0 && (
                                <div className="mt-3">
                                    <div className="text-danger fw-bold">Import Notes</div>
                                    <ul className="mb-0">
                                        {feeAdjustErrors.map((err, idx) => (
                                            <li key={`fee-adjust-error-${idx}`}>{err}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StartNewMonth2;